// Client-side domain validation + IDN punycode conversion. Used by both
// OnboardingPage and NewProjectDialog so they reject obviously-invalid input
// before round-tripping through createProject + addScopeTarget (the backend
// returns 422 on bad domains, and rolling back a partial create is more
// painful than blocking the submit).

export function isValidDomain(raw: string): boolean {
  const host = raw
    .trim()
    .replace(/^https?:\/\//, "")
    .replace(/\/.*$/, "")
    .toLowerCase();
  if (!host || /\s/.test(host)) return false;
  const labels = host.split(".");
  if (labels.length < 2) return false;
  for (const label of labels) {
    if (!label || label.length > 63) return false;
    if (label.startsWith("-") || label.endsWith("-")) return false;
    if (!/^[\p{L}\p{N}-]+$/u.test(label)) return false;
  }
  const tld = labels[labels.length - 1];
  // Real TLDs are 2+ letters (incl. IDN like рф, 中国). Reject digits-only.
  return tld.length >= 2 && /^[\p{L}]+$/u.test(tld);
}

export function toAsciiDomain(raw: string): string {
  try {
    return new URL(`https://${raw}`).hostname;
  } catch {
    return raw.toLowerCase();
  }
}
